// extracted by mini-css-extract-plugin
export var editButton = "_od-0";